<template>
  <nd-dialog v-model="visible" close-btn :footer="false">
    <div class="dialog-box" :class="{hasCoupon}">
      <div class="check-detail" @click="jumpDetail">查看详情 ></div>
      <!-- 优惠券信息 -->
      <coupon-info
        v-if="hasCoupon"
        class="dialog-coupon-info"
        :couponDiscountValue="couponInfo.couponDiscountValue"
        :useEndTime="couponInfo.useEndTime "
        @updateTime="couponInfo.useEndTime=0"
      />
      <div class="review-button">
        <span class="real-price" @click="jumpBuy">立即重审 ¥{{ realPrice }}</span>
        <span class="original-price">原价 ¥{{ price }}</span>
        <div class="discount-float" v-if="!hasCoupon && remainTime>0">
          <van-count-down
            style="display: inline;color: inherit;font-size: inherit;"
            :time="remainTime"
            format="DD天HH时mm分"
          />后涨价
        </div>
      </div>
      <div class="protocol">
        开通即同意<span @click="routerToVipProtocol(supplier)">《会员用户协议》</span>
      </div>
    </div>
  </nd-dialog>
</template>

<script>
import { getKey } from '@/assets/utils'
import { Base64 } from 'js-base64'
import { generateUUID } from '@/services/stat'
import { mapActions } from 'vuex'

const deviceInfo = {
  terminal: getKey('terminal') || 'H5',
  appVersion: getKey('appVersion'),
  uuid: generateUUID()
}

// 重审卡弹窗
export default {
  name: 'RefusedPrivilegeDialog',
  components: {
    'coupon-info': () => import('@/components/coupon-info/index.vue')
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'credit' // credit: 授信 loan: 提现
    },
    amount: {
      type: Number,
      default: 29.9
    },
    price: {
      type: Number,
      default: 29.9
    },
    // 优惠价
    expirePrice: {
      type: Number,
      default: 0
    },
    // 优惠截止时间
    expireDate: {
      type: Number,
      default: 0
    },
    // 供应商
    supplier: {
      type: String,
      default: ''
    },
    couponInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasCoupon () {
      return this.couponInfo?.useEndTime - new Date().getTime() > 0
    },
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    remainTime () {
      const interval = new Date(this.expireDate).getTime() - new Date().getTime()
      return interval
    },
    realPrice () {
      return this.remainTime > 0 ? this.expirePrice : this.amount
    }
  },
  methods: {
    ...mapActions('vip', ['orderCreateX']),
    // 跳转福利详情页面
    jumpDetail () {
      this.jumpToKingCardPage()
    },
    // 放弃机会
    handleGiveup () {
      this.visible = false
    },
    // 跳转收银台页面
    async jumpBuy () {
      this.$emit('input')
      this.$report({
        id: 20298,
        args: {
          position:
            this.status === 'credit' ? 'credit_review_buy' : 'loan_review_buy',
          type: this.supplier
        }
      })
      const host = encodeURIComponent(window.location.href)
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      const device = Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )
      const goodsCd = 'SKC_M'
      const goodsGroupCd = 'KING'
      const origin = process.env.VUE_APP_PAYURL
      let url = `${origin}/pay?memberType=${goodsCd}&memberGoodsGroupCd=${goodsGroupCd}&discountPrice=${this
      .expirePrice || this.amount}&host=${host}&gid=${gid}&token=${token}&device=${device}&channel=${channel}&refurl=${window.location.origin}`
      if (this.couponInfo?.serialNo) {
        url += `&couponSerialNos=${this.couponInfo.serialNo}`
      }
      window.location.href = url
      // }
    },
    // 跳转协议页面
    routerToVipProtocol (supplier) {
      this.visible = false
      if (supplier === 'JI_WEI') {
        this.$router.push('/protocol/vip-jw')
      } else if (supplier === 'WH') {
        this.$router.push('/protocol/vip-wh')
      } else {
        this.$router.push('/protocol/vip')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

/deep/.nd-dialog-content {
  .default-content {
      background: none;
      width: 760px;
      height: 931px;
      padding: 0;
      margin: 0;
  }
}
.dialog-box {
  color: #333333;
  width: 760px;
  height: 931px;
  background: url(./images/pop_shouxin_king.png) no-repeat;
  background-size: 100%;
  .check-detail {
    width: 119px;
    height: 31px;
    font-size: 24px;
    font-weight: 400;
    color: #FFDEBA;
    padding-top: 290px;
    margin-left: 511px;
  }

  &.hasCoupon {
    .dialog-coupon-info {
      margin: 427px auto 0 auto;
      left:50%;
      transform: translateX(-50%);
      width: 495px;
      height: 80px;
    }
    .review-button {
      margin-top: 480px;
    }
  }
  .review-button {
    position: relative;
    width: 530px;
    height: 88px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 47px;
    margin: 417px auto 0 auto;
    text-align: center;
    .real-price {
      width: 253px;
      font-size: 36px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 88px;
    }
    .original-price {
      width: 120px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 88px;
      text-decoration: line-through;
      margin-left: 10px;
    }
    .discount-float {
        position: absolute;
        top: -20px;
        right: 130px;
        height: 40px;
        line-height: 40px;
        background: rgba(0,0,0,0.8);;
        border-radius: 20px 20px 20px 0px;
        padding: 0 20px;
        font-size: 20px;
        color: #FFFFFF;
      }
  }
  .protocol {
    width: 400px;
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #763E12;
    line-height: 33px;
    position: relative;
    text-align: center;
    span {
      border-bottom: 1px solid #763E12;
    }
    margin: 21px auto 0 auto;
  }
}
</style>
